const CONFIG = window.bcCartProgressConfig || {};
const PROGRESS_MAX = Number(CONFIG.max) || 100;
const TEXT_AWAY = CONFIG.textAway || "You are <strong>{amount} away</strong> from Free Shipping";
const TEXT_COMPLETE = CONFIG.textComplete || "You unlocked Free Shipping";

const clamp = (n, min, max) => Math.min(max, Math.max(min, n));

const renderProgressBar = (cartTotalInCents) => {
  const placeholder = document.getElementById("bc-progress-placeholder");
  if (!placeholder) return;

  if (cartTotalInCents <= 0) {
    placeholder.innerHTML = ""; // remove bar
    return;
  }

  const currentVal = cartTotalInCents / 100;
  const pct = clamp((currentVal / PROGRESS_MAX) * 100, 0, 100);
  const away = Math.max(PROGRESS_MAX - currentVal, 0);

  placeholder.innerHTML = `
    <div class="bc-progress-wrap my-2">
      <div class="bc-progress flex flex-col items-center">
        ${
          away > 0
            ? (() => {
                const formattedAmount = `$${away.toFixed(0)}`;
                const msg = TEXT_AWAY.replace('{amount}', formattedAmount);
                return `<div class="bc-progress-text" data-state="normal">${msg}</div>`;
              })()
            : `<div class="bc-progress-text" data-state="complete">${TEXT_COMPLETE}</div>`
        }

        <div class="bc-progress-track-wrapper flex items-center">
          <span>$0</span>

          <div class="bc-progress-track relative overflow-hidden">
            <div class="bc-progress-fill absolute inset-y-0 left-0 h-full transition-[width] duration-200 ease-linear"
              style="width: ${pct}%;">
            </div>
          </div>

          <span>$${PROGRESS_MAX}</span>
        </div>
      </div>
    </div>
  `;
};

document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartProgress', () => ({
    init() {
      // initial load
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => renderProgressBar(cart.total_price));

      // ADD TO CART
      document.body.addEventListener('switch:cart:afteradditem', (e) => {
        const cart = e?.detail?.response;
        if (cart && typeof cart.total_price !== 'undefined') {
          renderProgressBar(cart.total_price);
        } else {
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cartData) => renderProgressBar(cartData.total_price));
        }
      });

      // QTY CHANGE INSIDE DRAWER / PAGE
      document.body.addEventListener('switch:modalcart:cartqtychange', (e) => {
        const cart = e.detail?.response;
        if (!cart || typeof cart.total_price === 'undefined') return;
        renderProgressBar(cart.total_price);
      });
    },
  }));
});
